import {
  PRESCRIPTION_TYPE_FREE,
  PRESCRIPTION_TYPE_INSURANCE,
  PRESCRIPTION_TYPE_NO_PRESCRIPTION,
  PRESCRIPTION_TYPE_PRIVAT,
  PRODUCT_TEMPLATES,
} from 'shared/consts/productTemplates'

export const getPrescriptionTypeLabels = (i18n, productTemplate) => {
  const { OTC, OTX, RX } = PRODUCT_TEMPLATES

  const PRESCRIPTION_TYPES_OPTIONS_OTC = [
    {
      value: PRESCRIPTION_TYPE_NO_PRESCRIPTION,
      text: i18n._('prescription.options.noreceipt'),
    },
  ]

  const PRESCRIPTION_TYPES_OPTIONS_RX = [
    {
      value: PRESCRIPTION_TYPE_INSURANCE,
      text: i18n._('prescription.options.insurance'),
    },
    {
      value: PRESCRIPTION_TYPE_PRIVAT,
      text: i18n._('prescription.options.privatePrescription'),
    },
    {
      value: PRESCRIPTION_TYPE_FREE,
      text: i18n._('prescription.options.copaymentExempt'),
    },
  ]

  const PRESCRIPTION_TYPES_OPTIONS_OTX = [
    ...PRESCRIPTION_TYPES_OPTIONS_OTC,
    ...PRESCRIPTION_TYPES_OPTIONS_RX,
  ]

  switch (productTemplate) {
    case OTC:
      return PRESCRIPTION_TYPES_OPTIONS_OTC
    case OTX:
      return PRESCRIPTION_TYPES_OPTIONS_OTX
    case RX:
      return PRESCRIPTION_TYPES_OPTIONS_RX
    default:
      return []
  }
}
